import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainsearchresultComponent } from './mainsearchresult/mainsearchresult.component';
import { MainindexComponent } from './mainindex/mainindex.component';
import { MainbrowseTsicComponent } from './mainbrowse-tsic/mainbrowse-tsic.component';
import { MaincontractusComponent } from './maincontractus/maincontractus.component';
import { Notfoundpage404Component } from './notfoundpage404/notfoundpage404.component';


const routes: Routes = [
  { path: '',   redirectTo: '/index', pathMatch: 'full' },
  { path: 'index', component: MainindexComponent},
  { path: 'searchResult', component: MainsearchresultComponent},
  { path: 'brows_tsic', component: MainbrowseTsicComponent},
  { path: 'contact_us', component: MaincontractusComponent},
  { path: '**', component: Notfoundpage404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routiningComponents = [MainindexComponent, MainsearchresultComponent, MaincontractusComponent];
